import React, { useEffect } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { useIntl } from '../../util/reactIntl';
import { siteStaticPages } from '../../util/types';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, inProgress, error, history } = props;
  const pageId = params.pageId || props.pageId;
  const intl = useIntl();
  useEffect(() => {
    try {
      const locale = (intl?.locale || '').toLowerCase();
      const isDutch = locale.startsWith('nl');

      if (!history || !pageId) return;
      // Special case: Dutch landing CMS page should not be accessible in English
      if (!isDutch && pageId === 'nl-home') {
        history.replace('/');
        return;
      }

      const pages = siteStaticPages;

      // find current page
      const currentPage = pages.find(p => p?.pageId === pageId);
      // if (!currentPage) {
      //   history.replace('/notfound');
      //   return;
      // }

      // Normalize baseId by removing Dutch prefix or suffix
      const baseId = pageId.replace(/^nl-/, "").replace(/-nl$/, "");

      const enPage = pages.find(p => p?.language === 'en' && p?.pageId === baseId);
      const nlPage = pages.find(
        p => p?.language === 'nl' && (p?.pageId === `nl-${baseId}` || p?.pageId === `${baseId}-nl` || p?.pageId === baseId)
      );


      // CASE 1: Both pages exist → normal locale switching
      if (enPage && nlPage) {
        if (isDutch && pageId === enPage.pageId) {
          history.replace(`/p/${nlPage.pageId}`);
        } else if (!isDutch && pageId === nlPage.pageId) {
          history.replace(`/p/${enPage.pageId}`);
        }
        return;
      }

      // Fallback: Dutch locale, NL page missing but EN page exists → render English page
      if (isDutch && !nlPage && enPage) {
        history.replace(`/p/${enPage.pageId}`);
        return;
      }

      // CASE 2/3/4: Let hosted assets (Flex) decide and render or 404; don't force redirects here.

    } catch (err) {
      console.error("Locale auto-switch error:", err);
      // Don't force redirect; final 404 handling happens via hosted assets below.
    }
  }, [history, intl, pageId]);


  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps)
)(CMSPageComponent);

export default CMSPage;
